var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBett(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bed-svgrepo-com(1) 1",
    clipPath: "url(#clip0_19_138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M102.125 55.0703H4.40671C2.12359 55.0703 0.266113 56.9278 0.266113 59.2109V64.1796C0.266113 64.6368 0.636283 65.0078 1.09423 65.0078C1.55218 65.0078 1.92235 64.6368 1.92235 64.1796V59.2109C1.92235 57.8412 3.037 56.7266 4.40671 56.7266H102.125C103.495 56.7266 104.609 57.8412 104.609 59.2109V64.1796C104.609 64.6368 104.979 65.0078 105.437 65.0078C105.895 65.0078 106.265 64.6368 106.265 64.1796V59.2109C106.265 56.9278 104.408 55.0703 102.125 55.0703Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M100.469 76.6016H6.06298C5.60503 76.6016 5.23486 76.9726 5.23486 77.4297C5.23486 77.8868 5.60503 78.2578 6.06298 78.2578H100.469C100.927 78.2578 101.297 77.8868 101.297 77.4297C101.297 76.9726 100.927 76.6016 100.469 76.6016Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M105.437 63.3516H95.5C95.042 63.3516 94.6719 63.7226 94.6719 64.1797C94.6719 64.6368 95.042 65.0078 95.5 65.0078H104.609V77.4296C104.609 77.8867 104.979 78.2577 105.437 78.2577C105.895 78.2577 106.266 77.8867 106.266 77.4296V64.1797C106.266 63.7226 105.895 63.3516 105.437 63.3516Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.875 63.3516H1.09423C0.636283 63.3516 0.266113 63.7226 0.266113 64.1797V77.4296C0.266113 77.8867 0.636283 78.2577 1.09423 78.2577C1.55218 78.2577 1.92235 77.8867 1.92235 77.4296V65.0078H88.875C89.3329 65.0078 89.7031 64.6368 89.7031 64.1797C89.7031 63.7226 89.3329 63.3516 88.875 63.3516Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.06295 76.6016C5.605 76.6016 5.23483 76.9726 5.23483 77.4297V85.7109H1.92235V77.4297C1.92235 76.9726 1.55218 76.6016 1.09423 76.6016C0.636283 76.6016 0.266113 76.9726 0.266113 77.4297V86.539C0.266113 86.9961 0.636283 87.3671 1.09423 87.3671H6.06295C6.5209 87.3671 6.89107 86.9961 6.89107 86.539V77.4297C6.89107 76.9726 6.5209 76.6016 6.06295 76.6016Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M105.437 76.6016C104.979 76.6016 104.609 76.9726 104.609 77.4297V85.7109H101.297V77.4297C101.297 76.9726 100.927 76.6016 100.469 76.6016C100.011 76.6016 99.6405 76.9726 99.6405 77.4297V86.539C99.6405 86.9961 100.011 87.3671 100.469 87.3671H105.437C105.895 87.3671 106.265 86.9961 106.265 86.539V77.4297C106.265 76.9726 105.895 76.6016 105.437 76.6016Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M97.1562 18.6331H9.37546C7.09234 18.6331 5.23486 20.4905 5.23486 22.7737V43.4767C5.23486 43.9338 5.60503 44.3048 6.06298 44.3048C6.52093 44.3048 6.8911 43.9338 6.8911 43.4767V22.7737C6.8911 21.4039 8.00575 20.2893 9.37546 20.2893H97.1562C98.5259 20.2893 99.6405 21.4039 99.6405 22.7737V43.4767C99.6405 43.9338 100.011 44.3048 100.469 44.3048C100.927 44.3048 101.297 43.9338 101.297 43.4767V22.7737C101.297 20.4905 99.4393 18.6331 97.1562 18.6331Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M6.32545 42.6909C5.8882 42.5443 5.42197 42.7812 5.27788 43.2143L0.309155 58.1204C0.164234 58.5544 0.39942 59.0231 0.832527 59.168C0.919479 59.197 1.00809 59.2111 1.09421 59.2111C1.4412 59.2111 1.76416 58.9916 1.8801 58.6446L6.84882 43.7385C6.99374 43.3045 6.75855 42.8358 6.32545 42.6909Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M106.223 58.1204L101.255 43.2142C101.11 42.7811 100.643 42.5451 100.207 42.6908C99.7731 42.8357 99.5387 43.3045 99.6836 43.7384L104.652 58.6446C104.767 58.9915 105.09 59.211 105.437 59.211C105.524 59.211 105.612 59.1977 105.7 59.1679C106.134 59.023 106.368 58.5543 106.223 58.1204Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M100.469 42.6487H93.0156C92.5577 42.6487 92.1875 43.0197 92.1875 43.4768C92.1875 43.9339 92.5577 44.3049 93.0156 44.3049H100.469C100.927 44.3049 101.297 43.9339 101.297 43.4768C101.297 43.0197 100.927 42.6487 100.469 42.6487Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M13.5161 42.6487H6.06298C5.60503 42.6487 5.23486 43.0197 5.23486 43.4768C5.23486 43.9339 5.60503 44.3049 6.06298 44.3049H13.5161C13.974 44.3049 14.3442 43.9339 14.3442 43.4768C14.3442 43.0197 13.974 42.6487 13.5161 42.6487Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M53.2658 31.883C53.7237 31.883 54.0939 31.512 54.0939 31.0549V30.2268C54.0939 27.9437 52.2364 26.0862 49.9533 26.0862H16.8285C14.5453 26.0862 12.6879 27.9437 12.6879 30.2268V43.4767C12.6879 45.7598 14.5453 47.6173 16.8285 47.6173H49.9533C52.2364 47.6173 54.0939 45.7598 54.0939 43.4767V36.8517C54.0939 36.3946 53.7237 36.0236 53.2658 36.0236C52.8078 36.0236 52.4376 36.3946 52.4376 36.8517V43.4767C52.4376 44.8464 51.323 45.9611 49.9533 45.9611H16.8285C15.4588 45.9611 14.3441 44.8464 14.3441 43.4767V30.2268C14.3441 28.8571 15.4588 27.7424 16.8285 27.7424H49.9533C51.323 27.7424 52.4376 28.8571 52.4376 30.2268V31.0549C52.4376 31.512 52.8078 31.883 53.2658 31.883Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M89.7031 26.0862H56.5783C54.2952 26.0862 52.4377 27.9437 52.4377 30.2268C52.4377 30.6839 52.8079 31.0549 53.2659 31.0549C53.7238 31.0549 54.094 30.6839 54.094 30.2268C54.094 28.8571 55.2086 27.7424 56.5783 27.7424H89.7031C91.0729 27.7424 92.1875 28.8571 92.1875 30.2268V43.4767C92.1875 44.8464 91.0729 45.9611 89.7031 45.9611H56.5783C55.2086 45.9611 54.094 44.8464 54.094 43.4767C54.094 43.0196 53.7238 42.6486 53.2659 42.6486C52.8079 42.6486 52.4377 43.0196 52.4377 43.4767C52.4377 45.7598 54.2952 47.6173 56.5783 47.6173H89.7031C91.9863 47.6173 93.8438 45.7598 93.8438 43.4767V30.2268C93.8438 27.9437 91.9863 26.0862 89.7031 26.0862Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    fill: "white",
    transform: "translate(0.266113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBett);
export default __webpack_public_path__ + "static/media/bett.84a5f072d25df4dec5da1e058374bde8.svg";
export { ForwardRef as ReactComponent };